import { ClosePositionMulticall } from './actions/ClosePositionMulticall';
import { IncreasePositionMulticall } from './actions/IncreasePositionMulticall';
var actions = {
    ClosePositionMulticall: ClosePositionMulticall,
    IncreasePositionMulticall: IncreasePositionMulticall,
};
var getters = {
// DataStore,
// DepositHandler,
// EventEmitter,
// OrderHandler,
// RoleStore,
// Router,
// WithdrawalHandler,
// GetMarkets,
};
var GMX = {
    actions: actions,
    getters: getters,
};
export { GMX };
